"use client";

import { useState } from "react";
import { ArrowRight } from "lucide-react";

import { ContactForm } from "@/components/forms/ContactForm";
import { Button } from "@/components/primitives/Button";
import { Modal } from "@/components/primitives/Modal";
import { getFormsCopy } from "@/content/forms";
import { track } from "@/lib/analytics";
import { useLocale } from "@/lib/i18n/provider";

type Props = {
  label: string;
  variant?: "primary" | "secondary" | "ghost";
  size?: "sm" | "md" | "lg";
  className?: string;
  mode?: "button" | "text";
  showArrow?: boolean;
};

export function ContactCTA({
  label,
  variant = "primary",
  size = "lg",
  className = "",
  mode = "button",
  showArrow = false,
}: Props) {
  const { locale } = useLocale();
  const forms = getFormsCopy(locale);
  const [open, setOpen] = useState(false);

  return (
    <>
      {mode === "text" ? (
        <button
          type="button"
          onClick={() => {
            track("cta_clicked", { cta: "contact" });
            setOpen(true);
          }}
          className={`text-left text-sm text-[var(--color-text-secondary)] transition-colors hover:text-[var(--color-text-primary)] ${className}`.trim()}
        >
          {label}
        </button>
      ) : (
        <Button
          type="button"
          variant={variant}
          size={size}
          className={`group ${className}`.trim()}
          onClick={() => {
            track("cta_clicked", { cta: "contact" });
            setOpen(true);
          }}
        >
          {label}
          {showArrow ? (
            <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          ) : null}
        </Button>
      )}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title={forms.modals.contact.title}
        description={forms.modals.contact.description}
        size="md"
      >
        <ContactForm />
      </Modal>
    </>
  );
}

export default ContactCTA;
